







































import { DepartmentColor } from "@/api";
import { VForm } from "@/common/vuetify_types";
import { Vue, Component, Ref, Prop } from "vue-property-decorator";

@Component
export default class DepartmentColorForm extends Vue {
  @Ref("form") form!: VForm;
  @Prop() departmentColor!: string;
  @Prop() departmentId!: number;
  @Prop() colorId!: number;

  loading = false;
  color = this.departmentColor;

  getPayload() {
    return {
      id: this.departmentId,
      color: {
        color: this.color,
      },
    } as DepartmentColor;
  }

  async update() {
    this.loading = true;
    const payload = this.getPayload();
    payload.color.id = this.colorId;
    await this.$store.dispatch("departmentAdmin/updateDepartmentColor", {
      departmentId: this.departmentId,
      requestBody: payload,
    });
    this.loading = false;
    this.close();
  }

  async save() {
    this.loading = true;
    const payload = this.getPayload();
    await this.$store.dispatch("departmentAdmin/addDepartmentColor", {
      departmentId: this.departmentId,
      requestBody: payload,
    });
    this.loading = false;
    this.close();
  }

  close() {
    this.form.reset();
    this.$emit("close");
  }
}
